import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logoURLTesifive from '../../../../assets/tesifive.png';
import { cargarImagen } from '../../../../utils/utils';

// ===================================================================================
// FUNCIÓN PARA GENERAR EL PDF DEL CALENDARIO DE AVANCES (DISEÑO MEJORADO)
// ===================================================================================
const generarPdfCalendarioTesis = async (servicio, solicitud) => {
  
  // --- 1. Inicialización del Documento ---
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  const margin = 15;
  let currentY = 0;

  // Paleta de colores para un diseño profesional
  const paleta = {
    primario: '#1E3A8A', // Un azul más intenso
    secundario: '#60A5FA', // Azul claro para detalles
    textoPrincipal: '#1F2937', // Casi negro para mejor legibilidad
    textoSecundario: '#6B7280', // Gris para textos secundarios
    borde: '#E5E7EB',
    fondoTitulo: '#F9FAFB',
    fondoFilaPar: '#F3F4F6', // Color para las filas pares de la tabla
  };

  // NUEVO: Cargar y añadir el logo
  try {
    const logoImg = await cargarImagen(logoURLTesifive);
    
    // MODIFICADO: Hacemos el logo más grande (de 15 a 20)
    const logoHeight = 20; 
    const logoWidth = (logoImg.width * logoHeight) / logoImg.height;
    
    // MODIFICADO: Calculamos la posición 'x' para centrar el logo
    const logoX = (pageWidth - logoWidth) / 2;
    
    // Añadimos la imagen en la nueva posición centrada
    doc.addImage(logoImg, 'PNG', logoX, margin, logoWidth, logoHeight);

  } catch (error) {
    console.error("Error al cargar el logo:", error);
    doc.text("TesiFive", margin, 25);
  }

  // --- 2. Encabezado y Título ---

  // MODIFICADO: Ajustamos la posición vertical inicial para que el texto quede debajo del logo
  currentY = margin + 28; // Empezamos a escribir debajo del logo que está en y=15 y mide 20 de alto

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(24);
  doc.setTextColor(paleta.primario);
  // MODIFICADO: Volvemos a centrar el texto principal
  doc.text('TesiFive', pageWidth / 2, currentY, { align: 'center' });
  
  currentY += 8;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(12);
  doc.setTextColor(paleta.textoSecundario);
  // MODIFICADO: Centramos también el eslogan
  doc.text('¡Tu tesis en cinco!', pageWidth / 2, currentY, { align: 'center' });
  
  currentY += 20;
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(paleta.textoPrincipal);
  doc.text('Cronograma de Avances', pageWidth / 2, currentY, { align: 'center' });
  
  currentY += 15;
  
  // --- 3. Caja de Información del Proyecto (Diseño Mejorado) ---
  const boxWidth = pageWidth - (margin * 2);
  const boxPadding = 7;

  // Título de la caja
  doc.setFillColor(paleta.fondoTitulo);
  doc.setDrawColor(paleta.borde);
  doc.roundedRect(margin, currentY, boxWidth, 10, 3, 3, 'FD'); // Caja con bordes redondeados
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(paleta.primario);
  doc.text('INFORMACIÓN DEL PROYECTO', margin + boxPadding, currentY + 7);
  currentY += 10;

  // Contenido de la caja
  const tema = solicitud?.objetoFaltante?.temaTesis || 'No especificado';
  const temaLines = doc.splitTextToSize(tema, boxWidth - (boxPadding * 2) - 15);
  const carrera = solicitud?.objetoFaltante?.carrera || 'No especificada';
  const carreraLines = doc.splitTextToSize(carrera, boxWidth - (boxPadding * 2) - 20);

  // Se calcula la altura dinámicamente
  const infoBoxHeight = 10 + (temaLines.length * 5) + (carreraLines.length * 5);
  doc.setDrawColor(paleta.borde);
  doc.roundedRect(margin, currentY, boxWidth, infoBoxHeight, 3, 3, 'S'); // 'S' para solo borde
  
  let infoY = currentY + 8;
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(paleta.textoPrincipal);
  doc.text('Tema:', margin + boxPadding, infoY);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(paleta.textoSecundario);
  doc.text(temaLines, margin + boxPadding + 15, infoY);
  
  infoY += (temaLines.length * 5) + 4;
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(paleta.textoPrincipal);
  doc.text('Carrera:', margin + boxPadding, infoY);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(paleta.textoSecundario);
  doc.text(carreraLines, margin + boxPadding + 20, infoY);

  currentY += infoBoxHeight + 15;

  // --- 4. Tabla de Avances (Estilo "striped" y Lógica de Filas) ---
  const tableData = [];
  const avances = servicio.objetoTesis?.calendarioAvances || [];

  avances.forEach(avance => {
    if (avance && avance.detalle) {
      let fechaFormateada = "Fecha Pendiente";
      if (avance.fechaEntrega && !isNaN(new Date(avance.fechaEntrega))) {
          fechaFormateada = new Date(avance.fechaEntrega + 'T00:00:00').toLocaleDateString('es-ES', {
              day: '2-digit', month: '2-digit', year: 'numeric'
          });
      }
      tableData.push([`• ${avance.detalle}`, fechaFormateada]);
    }
  });

  autoTable(doc, {
    startY: currentY,
    head: [['Detalle de Avance', 'Fecha de Entrega']],
    body: tableData,
    theme: 'striped', // <-- ESTILO MÁS LIMPIO
    headStyles: { 
      fillColor: paleta.primario, 
      textColor: '#FFFFFF', 
      fontStyle: 'bold', 
      halign: 'center',
      fontSize: 11
    },
    styles: { 
      fontSize: 10, 
      cellPadding: 4, 
      textColor: paleta.textoPrincipal,
      valign: 'middle'
    },
    alternateRowStyles: {
        fillColor: paleta.fondoFilaPar // Color para filas alternas
    },
    columnStyles: {
      0: { cellWidth: 'auto', fontStyle: 'normal' },
      1: { halign: 'center', cellWidth: 40, fontStyle: 'bold' },
    },
  });

  // --- 5. Pie de Página ---
  const pageHeight = doc.internal.pageSize.height;
  
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(paleta.primario);
  doc.text('#NosotrosLoHacemosPorTi', pageWidth / 2, pageHeight - 20, { align: 'center' });

  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(paleta.textoSecundario);
  doc.text('www.dufyasesorias.com | asesor@dufyasesorias.com', pageWidth / 2, pageHeight - 14, { align: 'center' });
  
  // --- 6. Guardar el PDF ---
  const fechaHoy = new Date().toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '-');
  const nombreArchivo = `Cronograma_Tesis_${servicio.codigo}_${fechaHoy}.pdf`;
  doc.save(nombreArchivo);
};

export default generarPdfCalendarioTesis;